import type { CellContext } from '@tanstack/react-table'

import type { Statement } from '@/modules/projects'

export const NumberOfPagesCell = (cell: CellContext<Statement, string>) => (
  <div className="text-left">{cell.getValue()}</div>
)
